<app-simple-stacked-bar-chart
  [data]="data"
  [loading]="isLoading"
  [leftLabel]="'charts.labels.tutor' | translate"
  [rightLabel]="'charts.labels.time' | translate"
  [formatValue]="formatFunction"
></app-simple-stacked-bar-chart>
